/* eslint-disable jsx-a11y/anchor-is-valid */
import { IReview } from "api/interfaces/home/home.type";
import StarRatings from "component/design-system/StarRatings";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import Text, { TEXT_TYPE } from "component/design-system/typography/Text";
import IsHydrated from "helpers/IsHydrated";
import SafeLink from "modules/components/SafeLink";
import { useTranslation } from "next-i18next";
import { useRef, useState } from "react";
import HideIf from "util/HideIf";
import { dateToYMD } from "util/date-helper";
import styles from "./customerReview.module.scss";

function CustomerReview(props: IReview) {
  const {
    updateTime, rating, isOldReview, link,
  } = props;
  const viewModeDivRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const { t } = useTranslation("common");

  function toggleExpand(e) {
    e.preventDefault();
    setExpanded((_expanded: any) => !_expanded);
  }

  function CustomerReviewCard() {
    return (
      <div className={styles.customer_bubble}>

        <div className={styles.review_title}>{props.title}</div>

        <div className={styles.quote}>

          <div className={`${expanded ? styles.content_show_all : styles.content_not_show_all}`} ref={viewModeDivRef}>

            <span className={styles.review_quote}>{props.review}</span>
          </div>
          <HideIf show={viewModeDivRef.current?.scrollHeight > 130}>
            <p style={{ textAlign: "right", cursor: "pointer" }} className={styles.see_more_less}>

              {expanded ? (
                <span className="p-t-10" onClick={toggleExpand}>{t("See less")}</span>
              ) : (
                <span className="p-t-10" onClick={toggleExpand}>{`... ${t("See more")}`}</span>
              )}
            </p>
          </HideIf>
        </div>
      </div>
    );
  }

  return (
    <div className={` ${styles.customer_review_container} customer-review`}>
      <HideIf show={link}>
        <SafeLink href={link} target="_blank">
          <CustomerReviewCard />
        </SafeLink>
      </HideIf>
      <HideIf show={!link}>
        <CustomerReviewCard />
      </HideIf>

      <div className={styles.customer_profile}>
        <div className={styles.name}>{props.name}</div>
        <IsHydrated>
          <Text size={6} type={TEXT_TYPE.secondary} className={styles.full_width}>{dateToYMD(new Date(isOldReview ? props.date : updateTime))}</Text>
        </IsHydrated>

        <div className={`${styles.full_width} d-flex align-items-center flex-wrap text-center p-t-10 justify-content-center`}>

          <div className="text-left p-l-0">

            <StarRatings
              rating={rating}
              style={{ height: 20 }}
            />
          </div>

          <PAText bold className="p-l-5" fontSize={FONT_SIZE[2]}>
            {isOldReview ? props.overall : rating}
            /5
          </PAText>
        </div>
      </div>
    </div>
  );
}

export default CustomerReview;
